module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('demo', {
    attrs: {
      "title": "Btn"
    }
  }, [_c('demo-item', {
    attrs: {
      "name": "size",
      "description": "按钮大小",
      "code": _vm.size_code
    },
    slot: "left"
  }, [_c('div', {
    staticClass: "btn-group"
  }, [_c('Btn', {
    attrs: {
      "size": 'sm'
    }
  }, [_vm._v("小尺寸")]), _vm._v(" "), _c('Btn', {
    attrs: {
      "size": 'md'
    }
  }, [_vm._v("中尺寸")]), _vm._v(" "), _c('Btn', {
    attrs: {
      "size": 'lg'
    }
  }, [_vm._v("大尺寸")])], 1)]), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "icon",
      "description": "前后置图标",
      "code": _vm.icon_code
    },
    slot: "right"
  }, [_c('div', {
    staticClass: "btn-group"
  }, [_c('Btn', {
    attrs: {
      "prefix": 'arrowleft'
    }
  }, [_vm._v("Left")]), _vm._v(" "), _c('Btn', {
    attrs: {
      "prefix": 'arrowright'
    }
  }, [_vm._v("Right")]), _vm._v(" "), _c('Btn', {
    attrs: {
      "suffix": 'arrowup'
    }
  }, [_vm._v("Up")]), _vm._v(" "), _c('Btn', {
    attrs: {
      "suffix": 'arrowdown'
    }
  }, [_vm._v("Down")])], 1)]), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "status",
      "description": "按钮状态",
      "code": _vm.status_code
    },
    slot: "left"
  }, [_c('div', {
    staticClass: "btn-group"
  }, [_c('Btn', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Disabled")]), _vm._v(" "), _c('Btn', {
    attrs: {
      "is_loading": true,
      "loading_text": "Loading.."
    }
  }, [_vm._v("Btn")])], 1)]), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "style",
      "description": "自定义样式",
      "code": _vm.style_code
    },
    slot: "right"
  }, [_c('div', {
    staticClass: "btn-group"
  }, [_c('Btn', {
    class: 'solid-btn',
    attrs: {
      "prefix": 'rollback'
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('Btn', {
    class: 'star-btn',
    attrs: {
      "prefix": 'star'
    }
  }, [_vm._v("Star")]), _vm._v(" "), _c('Btn', {
    class: 'cir-btn',
    attrs: {
      "prefix": 'search'
    }
  }), _vm._v(" "), _c('Btn', {
    class: 'fixed-width-btn',
    attrs: {
      "suffix": 'shoppingcart',
      "size": 'lg'
    }
  }, [_vm._v("购买")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68500490"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/demo/Btn.vue
// module id = 670
// module chunks = 0